import React from "react";
import ReactApexChart from "react-apexcharts";
import { Spin } from "antd";

function EChart({ activeUsersByDate, loading, height = 350 }) {
  const chartSeries = [
    {
      name: "Active Users",
      data: activeUsersByDate?.map((item) => item.users) || [],
    },
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      width: "100%",
      height: "auto",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: { horizontal: false, columnWidth: "55%", borderRadius: 4 },
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 1, colors: ["transparent"] },
    grid: { show: true, borderColor: "#f0f0f0", strokeDashArray: 2 },
    xaxis: {
      categories: activeUsersByDate?.map((item) => item.date) || [],
    },
    yaxis: {
      min: 0,
      labels: {},
    },
    tooltip: {
      y: { formatter: (val) => val + " users" },
    },
  };

  if (loading) {
    return (
      <div style={{ minHeight: height, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin tip="Loading chart..." />
      </div>
    );
  }

  return (
    <ReactApexChart
      options={chartOptions}
      series={chartSeries}
      type="bar"
      height={height}
      width="100%"
    />
  );
}

export default EChart;
